import React from 'react'
import SupplyChainForm from '../SupplyChain/SupplyChain'

export function ThirdPartySellerDomainInput({
  thirdPartyReferenceChainId,
  setThirdPartyReferenceChainId,
  errorMessage,
  disabled,
}: {
  thirdPartyReferenceChainId: string | null
  setThirdPartyReferenceChainId: (chainId: string | null) => void
  errorMessage: string
  disabled: boolean
}) {
  return (
    <SupplyChainForm
      thirdPartyReferenceChainId={thirdPartyReferenceChainId}
      onChange={({ thirdPartyReferenceChainId }) =>
        setThirdPartyReferenceChainId(thirdPartyReferenceChainId || null)
      }
      errors={{ thirdPartyReferenceChainId: errorMessage }}
      disabled={disabled}
      gap={32}
    />
  )
}
